<template>
  <div>
    <div>
      <el-form ref="form" :model="attrForm" label-width="80px" size="mini">
        <el-form-item label="颜色">
          <el-color-picker :color-format="'hex'" v-model="attrForm.color">
          </el-color-picker>
        </el-form-item>
        <el-form-item label="线宽">
          <el-input-number
            v-model="attrForm.width"
            controls-position="right"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="文本">
          <el-input v-model="attrForm.text" controls-position="right"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-html="svgElement" id="drawing" class="svg-board"></div>
    <div class="svg-btns">
      <el-button-group>
        <el-button size="mini" @click="changeColor" type="primary">修改颜色</el-button>
        <el-button size="mini" @click="changeWidth" type="primary">修改线宽</el-button>
        <el-button size="mini" @click="changeText" type="primary">修改文字</el-button>
        <el-button size="mini" @click="downPng" type="primary">下载图片</el-button>
        <el-button size="mini" @click="saveAttr" type="primary">保存修改</el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
//--常規
//--文本
//--衬线
//--辅件
//--信息
//--尾线
import { SVG } from "@svgdotjs/svg.js";
import { svg2CanvasExt, download } from "@/utils/image.js";
import { getCommonAjax } from "@/api/common.js";
export default {
  props: ["subData"],
  data() {
    return {
      attrForm: {
        color: "",
        width: 1,
        text: "",
      },
      svgElement: "",
      timer: undefined,
      SVGObj: undefined,
    };
  },
  computed: {},
  async created() {
    const res = await getCommonAjax(this.subData.image);
    this.svgElement = res;
  },
  mounted() {
    this.$nextTick(() => {
      let node = null;
      this.timer = setInterval(() => {
        node = document.getElementById("svg2"); //获取元素
        if (node) {
          clearInterval(this.timer);
          this.initSVGObj(node);
          this.initAttrs();
        }
      }, 1);
    });
  },
  methods: {
    initSVGObj(node) {
      if (this.SVGObj) {
        return this.SVGObj;
      }
      this.SVGObj = SVG(node);
      return this.SVGObj;
    },
    initAttrs() {
      //初始化属性
      var pathArr = this.SVGObj.find("path");
      var textArr = this.SVGObj.find("text");
      this.attrForm.color = pathArr.css("stroke")[0];
      this.attrForm.width = pathArr.css("stroke-width");
      this.attrForm.text = textArr.text()[0];
      console.log(this.attrForm);
    },
    downPng() {
      let element = document.getElementById("svg2"); //获取元素
      svg2CanvasExt(element, (canvas) => {
        download(canvas.toDataURL("image/png"), "标绘.png");
      });
    },
    saveAttr() {
      let element = document.getElementById("svg2"); //获取元素
      svg2CanvasExt(element, (canvas) => {
        var url=canvas.toDataURL("image/png");
        console.log(url);
        this.$bus.$emit("saveAttr", url);
      });
    },
    changeText() {
      var textArr = this.SVGObj.find("text");
      textArr.tspan(this.attrForm.text);
    },
    changeColor() {
      var pathArr = this.SVGObj.find("path");
      pathArr.css("stroke", this.attrForm.color);
    },

    changeWidth() {
      var pathArr = this.SVGObj.find("path");
      pathArr.css("stroke-width", this.attrForm.width);
    },
    setStyle(style, att, value) {
      var atts = style.split(";");
      var orig = undefined;
      for (var i = 0; i < atts.length; i++) {
        var arrPro = atts[i].split(":");
        if (arrPro[0] == att) {
          orig = arrPro[1];
          break;
        }
      }
      var before = att + ":" + orig;
      var after = att + ":" + value;
      const regExp = new RegExp(`${before}`, "ig");
      const str = style.replace(regExp, after);
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-board {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  padding: 20px 0;
}

.svg-btns {
  margin-top: 10px;
  text-align: center;
}
</style>
